export function validatePassword(password) {
  const rules = [
    { id: 'length',   label: 'Mínimo 8 caracteres',          test: (p) => p.length >= 8 },
    { id: 'uppercase',label: 'Al menos una mayúscula (A-Z)', test: (p) => /[A-Z]/.test(p) },
    { id: 'lowercase',label: 'Al menos una minúscula (a-z)', test: (p) => /[a-z]/.test(p) },
    { id: 'number',   label: 'Al menos un número (0-9)',      test: (p) => /[0-9]/.test(p) },
        { id: 'special', label: 'Al menos un carácter especial (!@#$%...)', test: (p) => /[!@#$%^&*()_+\-={}|,.<>?]/.test(p) },
  ]

  const results = rules.map((rule) => ({ ...rule, passed: rule.test(password) }))
  const isValid = results.every((r) => r.passed)
  const passedCount = results.filter((r) => r.passed).length
  const strength = passedCount <= 2 ? 'débil' : passedCount <= 4 ? 'media' : 'fuerte'

  return { isValid, rules: results, strength, passedCount }
}

export function getStrengthColor(strength) {
  switch (strength) {
    case 'débil':  return '#ef4444'
    case 'media':  return '#f59e0b'
    case 'fuerte': return '#22c55e'
    default:       return '#d1d5db'
  }
}